import React, { useState, useRef } from 'react';
import PageLayout from 'src/common/components/PageLayout';
import { Button, makeStyles, Grid } from '@material-ui/core';
import Upload from 'src/common/components/Upload';
import FullTable from 'src/common/components/FullTable';
import { columns, columsHeader } from './utils/list_data';
import ConfirmFileModal from './Modals/ConfirmFileModal';
import { sessionsAPI } from 'src/api/modules/sessions';
import notice from 'src/common/components/Notice';
import AntTabs from 'src/common/components/AntTabs';
import { useSelector } from 'react-redux';

const useStyles = makeStyles({
	root: {
		margin: 0,
		width: '100%',
	},
	containerButtons: {
		display: 'flex',
		justifyContent: 'flex-end',
		width: '100%',
		padding: '20px 0px 20px 0px',
	},
});

const LoadSessions = () => {
	const classes = useStyles();
	const [tabValue, setTabValue] = useState(0);
	const [dataForApi, setdataForApi] = useState([]);
	const [dataRow, setdataRow] = useState(dataForApi);
	const [confirmModal, setConfirmModal] = useState(false);
	const [showTable, setshowTable] = useState(false);
	const [disabledBtnSubir, setDisabledBtnSubir] = useState(true);
	const [selectFile, setSelectFile] = useState(null);
	const [fileBase64, setFileBase64] = useState(null);
	const [nameFile, setNameFile] = useState(null);
	const { user } = useSelector((state) => state.auth);
	const isDev = process.env.REACT_APP_ENVIRONMENT === 'DEV';
	let name;

	const parseJson = (data) => {
		let result = [];
		const keys = Object.keys(data);
		keys.forEach((x) => {
			let filas = [];
			const valor = data[x];
			valor.forEach((fila) => {
				const Fila = getColumna(0, fila);
				const numeroSesion = getColumna(0, fila);
				const fecha = getColumna(1, fila);
				const hora = getColumna(2, fila);
				const fundamentoJuridico = getColumna(3, fila);
				const nombreCorto = getColumna(4, fila);
				filas.push({
					id: fila.fila,
					NumeroSesion: getMessage(numeroSesion),
					Fecha: getMessage(fecha),
					Hora: getMessage(hora),
					FundamentoJuridico: getMessage(fundamentoJuridico),
					NombreCorto: getMessage(nombreCorto),
					Mensaje: Fila.mensaje,
				});
			});
			result.push({
				//	value: filas[0].id,
				label: x,
				filas: filas,
			});
		});

		setdataForApi(result);
		updateState(result);
	};
	const getColumna = (columna, fila) => {
		if (fila.contenido == undefined) {
			return fila;
		} else return fila.contenido.find((x) => x.columna == columna);
	};

	const getMessage = (colum) => {
		if (colum?.validacion == undefined) {
			return '';
		}
		if (colum?.validacion) {
			return 'Correcto';
		} else {
			return colum?.mensaje;
		}
	};
	const openConfirmModal = () => {
		setConfirmModal(true);
	};

	const closeConfirmModal = () => {
		setConfirmModal(false);
	};

	const handleChangeTab = (newValue) => {
		setTabValue(newValue);
		//let dataNewNumber = newValue - 1;
		const DataRows = [...dataForApi];
		const DataRow = DataRows[newValue].filas;
		setdataRow(DataRow);
		validateTable(DataRow);
	};

	const onSuccessModal = () => {
		setConfirmModal(false);
		UploadFile();
	};

	//UPLOAD COMPONENT FUNCTIONS
	const fileInputRef = useRef(null);
	const onTargetClick = () => {
		fileInputRef.current.click();
	};

	const validateTable = (dataRow) => {
		if (
			dataRow.length > 0 &&
			dataRow[0].NumeroSesion == '' &&
			dataRow[0].Mensaje !== undefined
		) {
			setshowTable(true);
			setDisabledBtnSubir(true);
		} else {
			setDisabledBtnSubir(false);
			setshowTable(false);
		}
	};
	const updateState = (data) => {
		const DataRows = [...data];
		const DataRow = DataRows[0].filas;
		setdataRow(DataRow);
		validateTable(DataRow);
	};

	const getBase64 = (File) => {
		return new Promise((resolve) => {
			let reader = new FileReader();
			// Convert the file to base64 text
			reader.readAsDataURL(File);
			reader.onload = () => {
				const base64String = reader.result
					.replace('data:', '')
					.replace(/^.+,/, '');
				resolve(base64String);
				const file64 = base64String;
				setFileBase64(file64);
				getDataFromApi(file64);
			};
		});
	};

	const onFileChange = async (files, event) => {
		const file = files[0];
		if (!file) return;

		setSelectFile(file);
		name = file.name;
		setNameFile(name);
		getBase64(file);
	};

	const getDataFromApi = (file64) => {
		const dataPost = {
			usuarioId: user.id,
			archivo64: file64,
			nombreArchivo: name,
		};
		sessionsAPI
			.postValidateFile({ ...dataPost })
			.then((res) => {

			if (res.codigo === 'SAOC-400' || res.codigo === 'SAOC: 500')
					notice(JSON.parse(JSON.stringify(res.mensaje)));
			else {
					notice('Precarga de sesiones exitosa', 'success');
					const array = res;
					parseJson(array);
				}
			})
			.catch((e) => {
				if (isDev) {
				if (e.response.data.mensaje === undefined) {
					notice('Ocurrió un error con su petición');
				} else
					notice(
						JSON.parse(JSON.stringify(e.response.data.mensaje)),
						'warning'
					);
				} else notice('Ha ocurrido un error con su petición');
			});
	};

	const dataPost = {
		usuarioId: user.id,
		archivo64: fileBase64,
		nombreArchivo: nameFile,
	};

	const UploadFile = () => {
		sessionsAPI
			.postUploadFile({ ...dataPost })
			.then((res) => {
				notice('Carga de sesiones exitosa', 'success');
				setSelectFile(null);
			})
			.catch((e) => {
				if (isDev) {
				if (e.response.data.mensaje === undefined) {
					notice('Ocurrió un error con su petición');
				} else
					notice(
						JSON.parse(JSON.stringify(e.response.data.mensaje)),
						'warning'
					);
				} else notice('Ha ocurrido un error con su petición');
			});
	};

	return (
		<PageLayout title="Cargar Sesiones">
			<Grid container className={classes.root} spacing={2}>
				<Grid item xs={1} md={1}></Grid>
				<Grid item xs={10} md={10}>
					<Upload
						selectFile={selectFile}
						onFileInputChange={(e) => onFileChange(e.target.files)}
						fileInputRef={fileInputRef}
						onTargetClick={onTargetClick}
						setSelectFile={setSelectFile}
						onDrop={(files) => onFileChange(files)}
					/>
				</Grid>
				<Grid item xs={1} md={1}></Grid>
				{selectFile !== null ? (
					<div style={{ width: '100%' }}>
						<Grid item md={12}>
							<div>
								<AntTabs
									value={tabValue}
									options={dataForApi}
									onChange={handleChangeTab}
								/>
								{showTable == true && (
									<FullTable
										items={dataRow}
										columns={columsHeader}
										paginateOptions={[]}
									/>
								)}
								{showTable == false && (
									<FullTable
										items={dataRow}
										columns={columns}
										paginateOptions={[]}
									/>
								)}
							</div>
						</Grid>
					</div>
				) : (
					'  '
				)}
			</Grid>
			{selectFile !== null ? (
				<div className={classes.containerButtons}>
					<Button
						disabled={disabledBtnSubir}
						className="btn btn-light-primary"
						onClick={openConfirmModal}
					>
						Subir Archivo
					</Button>
				</div>
			) : (
				'  '
			)}
			<ConfirmFileModal
				open={confirmModal}
				setOpen={setConfirmModal}
				onClose={closeConfirmModal}
				onSuccess={onSuccessModal}
				name={setSelectFile}
			/>
		</PageLayout>
	);
};

export default LoadSessions;
